<template>
  <div class="business-line-search">
    <DropList
      filterable
      :label="labels.get('Business Line Placeholder')"
      :data="businessLines"
      v-model="selectedBusinessLine"
      @change="onChange"
    ></DropList>
  </div>
</template>

<script>
import { DropList } from "clariant-vue3-forms";
import ServiceManager from "../services/service-manager";
export default {
  name: "BusinessLineSearch",
  components: { DropList },
  data() {
    return {
      labels: ServiceManager.getService(this, "Labels"),
      config: ServiceManager.getService(this, "Config"),
      state: ServiceManager.getService(this, "State"),
      dataLayer: ServiceManager.getService(this, "DataLayer"),
      businessLines: [],
      selectedBusinessLine: "",
    };
  },
  setup() {
    return {
      uniqueId: `BusinessLineSearch-${Date.now().toString(36) + Math.random().toString(36).substring(2)}`
    }
  },
  mounted() {
    this.state.subscribe(this.uniqueId, this.onStateChanged);
    this.businessLines = this.dataLayer.loadBusinessLines();
  },
  beforeUnmount() {
    this.state.unsubscribe(this.uniqueId);
  },
  methods: {
    onChange(val) {
      this.$emit("change", this.selectedBusinessLine);
    },
    onStateChanged(message, prop, val) {
      if (prop === "businessLines") {
        this.businessLines = val;
      }
    }
  },
};
</script>

<style>
.business-line-search > .cla-droplist-container {
  margin-bottom: 0 !important;
}

.business-line-search > div > .label-container {
  margin-bottom: 0 !important;
}
</style>
